import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Calendar from 'react-calendar';
import AvatarEditor from 'react-avatar-editor';
import Slider from 'react-rangeslider';
import 'react-rangeslider/lib/index.css';
import Button from 'react-responsive-ui/commonjs/Button';
import { FileUpload } from 'react-responsive-ui';
import {
    updateUserProfile,
    uploadProfilePicture,
    getPostsListForUser, 
    getUserProfile 
} from '../helpers/registrationHelper';
import Loading from '../components/Loading';
import Success from '../components/success';
import PostsList from '../components/newsline/postsList';
import More from '../components/more';

class Profile extends Component {
    constructor(props) {
        super(props);
        this.props = props
        this.state = {
            ableToLoadMore: true,
            isEditProfile: false
        }
        this.handleGenderChange = this.handleGenderChange.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleWeightChange = this.handleWeightChange.bind(this)
        this.handleHeightChange = this.handleHeightChange.bind(this)
        this.handleUpdatePhone = this.handleUpdatePhone.bind(this)
        this.updateProfile = this.updateProfile.bind(this)
        this.handleBirthdateChange = this.handleBirthdateChange.bind(this)
        this.handleUpdatePicture = this.handleUpdatePicture.bind(this)
        
        getUserProfile()
        .then((data) => {
            let values = Object.assign({}, data.data);
            values.picture = data.data.picture
            this.setState({ data: values })
        }).catch((error) => {
            console.log(error)
        })
        
        getPostsListForUser(localStorage.user_id)
            .then((response) => {
                if (!response.data.error) {
                    this.setState({ posts: response.data })
                } else {
                    console.log('get posts errored')
                }
            })
    }

    loadMore = (pageNumber) => {
        getPostsListForUser(localStorage.user_id, pageNumber)
            .then((response) => {
                if (!response.data.error) {
                    if(response.data.length > 0 )
                        this.setState(prevState => ({ posts: prevState.posts.concat(response.data) }))
                        else
                        this.setState({ ableToLoadMore: false})

                } else {
                    console.log('get posts errored')
                }
            })
    }

    handleGenderChange(from) {
        let data = Object.assign({}, this.state.data);
        if (from === 'MALE') {
            data.gender = 'M';
            this.setState({ data });
        } else {
            data.gender = 'F';
            this.setState({ data });
        }
    }

    saveSuccessMsg(message) {
        if (this.state) {
            let array = this.state.successMsg ? this.state.successMsg : []
            array.unshift({ message: message, index: array.length - 1 });
            this.setState({ successMsg: array })
        }
    }

    render() {
        if (!this.state) {
            return <Loading />
        } else if(this.state && this.state.isEditProfile){
            const weight = this.state.data.weight
            const height = this.state.data.height
            const draggedOver = false

            return (
                <div>
                    <Button action={() => this.switchView() }>
                    Stop editing my profile
                    </Button>
                    {this.state.successMsg && <Success successMsg={this.state.successMsg} />}
                    <h1> Profile page</h1>

                    <div className="profile-container">
                        <div className="profile-zone">
                            <label htmlFor="name">Name</label>
                            <input id="name" type="text" value={this.state.data.name} onChange={this.handleChange} />
                        </div>
                        <div className="profile-zone">
                            <label htmlFor="height">Height</label>
                            {/* <input id="Height" value={this.state.data.height} onChange={this.handleChange} /> */}
                            <div className='slider'>
                                <Slider
                                    min={2}
                                    max={9}
                                    step={0.05}
                                    value={height}
                                    onChange={this.handleHeightChange}
                                />
                            </div>
                            <div className="profile-zone">
                                <label htmlFor="weight">Weight</label>
                                <div className='slider'>
                                    <Slider
                                        min={20}
                                        max={400}
                                        value={weight}
                                        onChange={this.handleWeightChange}
                                    />
                                </div>
                            </div>
                            <div className="profile-zone">
                                <label htmlFor="birth">Birth date</label>
                                <Calendar
                                    onChange={this.handleBirthdateChange}
                                    value={new Date(this.state.data.birth_date)}
                                />
                            </div>
                            <div className="profile-zone">
                                <label htmlFor="sex">Gender</label>
                                <div onClick={() => { this.handleGenderChange('MALE') }} className={this.state.data.gender === 'M' ? "gender-selected" : "gender"}>
                                    Male
                            </div>
                                <div onClick={() => { this.handleGenderChange('FEMALE') }} className={this.state.data.gender === 'F' ? "gender-selected" : "gender"}>
                                    Female
                            </div>

                            </div>
                            <div className="profile-zone">
                                <label htmlFor="phone">Phone</label>
                                <input id={"phone"} type="phone" onChange={this.handleUpdatePhone} value={this.state.data.phone} />
                            </div>
                            <div className="profile-zone">
                                <label htmlFor="Profile picture">Profile picture</label>
                                <FileUpload
                                    action={(file) => this.handleUpdatePicture(file)}
                                    className={`file-upload ${draggedOver ? 'file-upload--dragged-over' : ''}`}>
                                    Click here to choose a profile picture
                            </FileUpload>
                                <AvatarEditor
                                    image={this.state.data.picture ? this.state.data.picture : "http://www.uni-regensburg.de/Fakultaeten/phil_Fak_II/Psychologie/Psy_II/beautycheck/english/durchschnittsgesichter/m(01-32)_gr.jpg"}
                                    width={150}
                                    height={150}
                                    border={50}
                                    color={[255, 255, 255, 0.6]} // RGBA
                                    scale={1.2}
                                    rotate={0}
                                    borderRadius={150}
                                />
                            </div>
                            <button onClick={this.updateProfile}>Save changes</button>
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <div>
                {this.state.data && <Button action={() => this.switchView() }>
                    Edit my profile
                    </Button>
                }
                    <div className="newsline-wrapper">
                        {this.state && this.state.posts && !this.state.isEditProfile && <PostsList posts={this.state.posts} />}
                        {this.state && this.state.posts && !this.state.isEditProfile && <More loadMore={ this.loadMore } ableToLoadMore={this.state.ableToLoadMore}/>}
                    </div>

                </div>
            )
        }
    }

    switchView = () => {
        this.setState(prevState => ({ isEditProfile: !prevState.isEditProfile }))
    }

    handleUpdatePicture(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            let data = Object.assign({}, this.state.data);
            data.picture = reader.result
            data.file = file
            this.setState({ data })
        }.bind(this);
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    handleWeightChange(value) {
        let data = Object.assign({}, this.state.data);
        data.weight = value;
        this.setState({ data });
    }

    handleUpdatePhone(event) {
        let data = Object.assign({}, this.state.data);
        data.phone = event.target.value;
        this.setState({ data });
        event.preventDefault();

    }

    handleHeightChange(value) {
        let data = Object.assign({}, this.state.data);
        data.height = value;
        this.setState({ data });
    }

    handleBirthdateChange(value) {
        let data = Object.assign({}, this.state.data);
        data.birth_date = value;
        this.setState({ data });
    }

    handleChange(event) {
        event.preventDefault();
        let data = Object.assign({}, this.state.data);
        data.name = event.target.value;
        this.setState({ data });

    }

    updateProfile() {
        var data = { photo: this.state.data.file, phone: this.state.data.phone, weight: this.state.data.weight, height: this.state.data.height, birth_date: this.state.data.birth_date, gender: this.state.data.gender }
        updateUserProfile(data)
            .then((response) => {
                if (!response.data.error) {
                    this.saveSuccessMsg("Profile updated successfully");
                } else {
                    this.setState({ errorsMsgs: [response.data.error], showModal: true });
                }
            })
        uploadProfilePicture(this.state.data.picture)
            .then((response) => {
                if (!response.data.error) {
                    this.saveSuccessMsg("Profile updated successfully");
                } else {
                    this.setState({ errorsMsgs: [response.data.error], showModal: true });
                }
            })

    }
}

Profile.propTypes = {
    history: PropTypes.object
};
export default Profile;


// WEBPACK FOOTER //
// ./src/containers/profile.js